import React, { Component } from 'react';

import SelectCommon from '../../NuevaSolicitudCuenta/components/Common/SelectCommonDefault'
class HabilitacionCajeros extends Component {
    constructor (props){
        super(props)
        this.state={
        }
    }

    render() {
        const{tarjetas, data, solicitudCuenta, selectCombo}=this.props
        const{HabilitacionCajeros,GET_PRODUCTO_DEFAULT_VISA_PRODUCTO}=solicitudCuenta
        let habilitacionCajero = HabilitacionCajeros.map(habilitacion => { return { Id: habilitacion.ID, Descripcion: habilitacion.CODIGO + " - " + habilitacion.DESCRIPCION}})
        let habilitacionDefault = GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.HabilitacionCajerosDefaultInterfaz ? GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.HabilitacionCajerosDefaultId : 0;
        
        //SI ES UNA CUENTA EXISTENTE, HABILITACIÓN DEFAULT ES LA DE LA TARJETA REGISTRADA CON EL ID MÁS ALTO
        if(tarjetas.esCuentaExistente && Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length>0 ){
            let idMayor = 0;
            data.cuentasAdicionales.map(cuenta=>{if(cuenta.Id>idMayor && cuenta.SolicitudId){idMayor = cuenta.Id ; habilitacionDefault = cuenta.HabilitacionCajerosId ? cuenta.HabilitacionCajerosId: 0 } });
        }
        
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Habilitación de Cajeros"}</label>
                    <div className="row">
                        <div className="col-xs-5">
                            <SelectCommon 
                                    valorCombo={habilitacionDefault}
                                    selecciones={data}
                                    infoData={habilitacionCajero} 
                                    selectCombo={selectCombo}
                                    nombreAction={"SelectHabilitacionCajeroAdicional"}
                             />
                        </div>
                    </div>
                </div>
                {(data.ERROR_ADICIONAL["seleccionoHabilitacionCajeros"] == false)
                    && <label className="error">{"Debe seleccionar habilitación de cajeros"}</label>
                }
            </div>
        )
    }
};

export default HabilitacionCajeros;